module.exports = __webpack_public_path__ + "img/IRanger64_ua.a99be04f.webp";